import c from "./consts";

export default {
  [c.IS_LOADING](state, value) {
    state[c.IS_LOADING] = value;
  },

  [c.COMPANY](state, value) {
    state[c.COMPANY] = value;
  },

  [c.STORM_WARNINGS](state, value) {
    state[c.STORM_WARNINGS] = value;
  },

  [c.COMPANY_DISPLAYS](state, value) {
    state[c.COMPANY_DISPLAYS] = value;
  }
}